// extracted by mini-css-extract-plugin
module.exports = {"allCards":"cards_allCards__cbORI","pagi":"cards_pagi__338eS","puedoCar":"cards_puedoCar__3VyuN"};